import React from 'react'

const OHPackagePopup = ({
  open,
  onClose,
  headcountInput,
  onHeadcountChange,
  parsedHeadcount,
  pricing,
  enquirySubmitting,
  enquiryStatus,
  onSubmit,
  formatGBP,
  minPackagePrice,
}) => {
  if (!open) return null

  const isSuccess = enquiryStatus === 'Enquiry sent to sales successfully.'
  const hasError =
    !!enquiryStatus &&
    enquiryStatus !== 'Enquiry sent to sales successfully.'

  return (
    <div className="fixed inset-0 z-[1000] p-4 flex items-center justify-center">
      <div className="absolute inset-0 bg-slate-900/50" onClick={onClose} />
      <div className="relative w-full max-w-6xl max-h-[90vh] overflow-y-auto bg-slate-100 rounded-2xl shadow-2xl p-4 sm:p-6">
        <div className="flex items-start justify-between mb-4 sm:mb-6">
          <h2 className="text-2xl font-semibold text-slate-700">
            Additional School Support Services
          </h2>
          <button
            type="button"
            className="text-slate-500 hover:text-slate-700 text-xl leading-none"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[2fr,1fr] gap-4">
          <div className="bg-[#b03570] rounded-2xl p-4 sm:p-6 text-white">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
              <div>
                <h3 className="text-3xl font-semibold">Occupational Health Plus</h3>
                <p className="mt-2 text-white/95 max-w-2xl">
                 OH+ includes unlimited Pre-Placement Questionnaires and unlimited Occupational Health Referrals. This includes independent Occupational Health Physician and Occupational Health Adviser guidance; plus direct access to DR HR, our doctoral-level HR expert. Enter your total headcount to receive tailored pricing for your comprehensive OH+ package.
                </p>
              </div>
              <div className="w-full sm:w-56">
                <input
                  type="number"
                  min="0"
                  value={headcountInput}
                  onChange={(e) => onHeadcountChange(e.target.value)}
                  placeholder="Add # of staff..."
                  className="w-full rounded-md px-3 py-2 text-slate-700"
                />
              </div>
            </div>

            <div className="mt-4 text-white/95">
              <div className="mt-2 text-sm sm:text-base">
                <span className="line-through opacity-80 mr-2">
                  {formatGBP(pricing.tier.standard)} per staff
                </span>
                <span className="font-semibold">
                  {formatGBP(pricing.tier.discounted)} per staff
                </span>
              </div>
            </div>
          </div>

          <div className="rounded-2xl border border-slate-300 p-4 sm:p-5 bg-white/40">
            <h3 className="text-3xl text-slate-600 font-medium mb-3">Summary</h3>

            <div className="space-y-2 text-slate-700 text-sm">
              <div>
                Headcount: <span className="font-semibold">{parsedHeadcount}</span>
              </div>
              <div>
                Standard total:{' '}
                <span className="line-through">{formatGBP(pricing.standardTotal)}</span>
              </div>
              <div>
                Discounted total:{' '}
                <span className="font-semibold text-green-700">
                  {formatGBP(pricing.discountedTotal)}
                </span>
              </div>
              {pricing.isMinimumPriceApplied && (
                <div>
                  Minimum package price applied:{' '}
                  <span className="font-semibold">{formatGBP(minPackagePrice)}</span>
                </div>
              )}
              <div>
                Saving:{' '}
                <span className="font-semibold text-green-700">
                  {formatGBP(pricing.savingsTotal)}
                </span>
              </div>
            </div>

            <div className="mt-6 space-y-3">
              {!isSuccess && (
                <button
                  type="button"
                  onClick={onSubmit}
                  disabled={enquirySubmitting}
                  className="w-full inline-flex justify-center rounded bg-green-500 hover:bg-green-600 disabled:opacity-60 text-white py-2.5 font-semibold"
                >
                  {enquirySubmitting ? 'Sending enquiry...' : 'Enquire'}
                </button>
              )}

              {isSuccess && (
                <div className="rounded-md border border-green-300 bg-green-50 px-3 py-2 text-sm text-green-800 font-medium">
                  Enquiry sent successfully. Our team will be in touch shortly.
                </div>
              )}

              {hasError && (
                <div className="rounded-md border border-rose-300 bg-rose-50 px-3 py-2 text-sm text-rose-700">
                  {enquiryStatus}
                </div>
              )}

              <button
                type="button"
                className="w-full text-sm text-slate-600 underline"
                onClick={onClose}
              >
                No thanks
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OHPackagePopup
